import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CATALOG_EMPTY_STATE_TRANSLATION_KEY } from "../constants";
var pt = /*#__PURE__*/_defineProperty({}, CATALOG_EMPTY_STATE_TRANSLATION_KEY, {
  CATALOG_EMPTY_STATE_CHIP_ALL: 'Todos',
  CATALOG_EMPTY_STATE_TITLE: 'O que você quer ver?',
  CATALOG_EMPTY_STATE_GO_TO_CATALOG: 'Ir para o catálogo',
  CATALOG_EMPTY_STATE_STUDY_PLAN_TITLE: 'Você ainda não criou seu plano de estudos',
  CATALOG_EMPTY_STATE_STUDY_PLAN_DESCRIPTION: 'Organize sua semana para alcançar seus objetivos de aprendizagem.',
  CATALOG_EMPTY_STATE_STUDY_PLAN_BUTTON: 'Criar plano de estudos',
  CATALOG_EMPTY_STATE_COURSES_TITLE: 'Cursos de {{name}}',
  CATALOG_EMPTY_STATE_SHOW_MORE: 'Ver cursos filtrados',
  CATALOG_EMPTY_STATE_COURSE_CARD_CTA: 'Ver detalhes'
});
export default pt;